import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../api/apiCaller";

export const GET_LIST_CAMPAIGNS = "GET_LIST_CAMPAIGNS";
export const GET_LIST_CAMPAIGNS_ERROR = "GET_LIST_CAMPAIGNS_ERROR";
export const GET_LIST_CAMPAIGNS_SUCCESS = "GET_LIST_CAMPAIGNS_SUCCESS";

export const COUNT_LIST_CAMPAIGNS = "COUNT_LIST_CAMPAIGNS";
export const COUNT_LIST_CAMPAIGNS_ERROR = "COUNT_LIST_CAMPAIGNS_ERROR";
export const COUNT_LIST_CAMPAIGNS_SUCCESS = "COUNT_LIST_CAMPAIGNS_SUCCESS";

export const ADD_NEW_CAMPAIGN = "ADD_NEW_CAMPAIGN";
export const ADD_NEW_CAMPAIGN_ERROR = "ADD_NEW_CAMPAIGN_ERROR";
export const ADD_NEW_CAMPAIGN_SUCCESS = "ADD_NEW_CAMPAIGN_SUCCESS";

export const EDIT_A_CAMPAIGNS = "EDIT_A_CAMPAIGNS";
export const EDIT_A_CAMPAIGNS_SUCCESS = "EDIT_A_CAMPAIGNS_SUCCESS";
export const EDIT_A_CAMPAIGNS_ERROR = "EDIT_A_CAMPAIGNS_ERROR";

export const DELETE_A_CAMPAIGN = "DELETE_A_CAMPAIGN";
export const DELETE_A_CAMPAIGN_SUCCESS = "DELETE_A_CAMPAIGN_SUCCESS";
export const DELETE_A_CAMPAIGN_ERROR = "DELETE_A_CAMPAIGN_ERROR";
/**
 * Reducer
 */

const initialState = {
  campaigns: [],
  error: false,
  count: 0,
  loading: false,
};

export const outBoundsReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_CAMPAIGNS:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        campaigns: action.payload,
      };
    case GET_LIST_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_CAMPAIGNS:
      return {
        ...state,
      };
    case COUNT_LIST_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_CAMPAIGN:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        campaign: action.payload,
      };
    case ADD_NEW_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_CAMPAIGNS:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        campaign: action.payload,
      };
    case EDIT_A_CAMPAIGNS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_CAMPAIGN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        campaign: action.payload,
      };
    case DELETE_A_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListCampaigns = (order, limit, skip, where) => ({
  type: GET_LIST_CAMPAIGNS,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListCampaigns = (where) => ({
  type: COUNT_LIST_CAMPAIGNS,
  data: {
    where,
  },
});

export const addNewCampaign = (name, note, timeStart, timeEnd) => ({
  type: ADD_NEW_CAMPAIGN,
  data: {
    name,
    note,
    timeStart,
    timeEnd,
  },
});

export const editCampaign = (id, name, note, timeStart, timeEnd) => ({
  type: ADD_NEW_CAMPAIGN,
  data: {
    id,
    name,
    note,
    timeStart,
    timeEnd,
  },
});

export const deleteCampaign = (id) => ({
  type: ADD_NEW_CAMPAIGN,
  data: {
    id,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListCampaigns,
      countListCampaigns,
      addNewCampaign,
      editCampaign,
      deleteCampaign,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListCampaignsApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/", { order, limit, skip, ...where });
};
const countListCampaignsApi = (where) => {
  return apiCaller.getLogs("/", { ...where });
};
const addNewCampaignsApi = (name, note, timeStart, timeEnd) => {
  return apiCaller.post("/", { name, note, timeStart, timeEnd });
};
const editCampaignsApi = (id, name, note, timeStart, timeEnd) => {
  return apiCaller.put(`/${id}`, { name, note, timeStart, timeEnd });
};
const deleteCampaignsApi = (id) => {
  return apiCaller.del(`/${id}`);
};

/**
 * sagas
 */

export const getListCampaignsFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CAMPAIGNS);
    try {
      const res = yield call(
        getListCampaignsApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_CAMPAIGNS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_CAMPAIGNS_ERROR, error });
    }
  }
};

export const countCampaignsFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CAMPAIGNS);
    try {
      const res = yield call(countListCampaignsApi, action.data.where);
      yield put({
        type: COUNT_LIST_CAMPAIGNS_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CAMPAIGNS_ERROR, error });
    }
  }
};

export const addNewCampaignsFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_CAMPAIGN);
    try {
      const res = yield call(
        addNewCampaignsApi,
        action.data.name,
        action.data.note,
        action.data.timeStart,
        action.data.timeEnd
      );
      yield put({ type: ADD_NEW_CAMPAIGN_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: ADD_NEW_CAMPAIGN_ERROR, error });
    }
  }
};

export const editCampaignsFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_CAMPAIGNS);
    try {
      const res = yield call(
        editCampaignsApi,
        action.data.id,
        action.data.name,
        action.data.note,
        action.data.timeStart,
        action.data.timeEnd
      );
      yield put({ type: EDIT_A_CAMPAIGNS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_A_CAMPAIGNS_ERROR, error });
    }
  }
};

export const deleteCampaignsFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_CAMPAIGN);
    try {
      const res = yield call(deleteCampaignsApi, action.data.id);
      yield put({ type: DELETE_A_CAMPAIGN_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_A_CAMPAIGN_ERROR, error });
    }
  }
};
